import { render, staticRenderFns } from "./PriceQuotationInfoData.vue?vue&type=template&id=851e4346&"
import script from "./PriceQuotationInfoData.vue?vue&type=script&lang=js&"
export * from "./PriceQuotationInfoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports